// @flow
import React, { type Element } from 'react';
import CompanyEdit from './CompanyEdit';

const CompanyList = (): Element<*> => <CompanyEdit />;

export default CompanyList;
